import {
  IGymNotificationByGymListingIdParams,
  IGymNotificationByUserIdParams,
  IGymNotificationGymsParams,
} from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { GymNotificationService } from "../../services/gym-notification.service";
import {
  IGymNotificationGym,
  IUserGymNotificationByGymResponse,
  IUserGymNotificationByUserResponse,
} from "../../models/GymNotification";

export const useGetGymNotificationGymsQuery = (data: IGymNotificationGymsParams) => {
  return useQuery<IGymNotificationGym[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_NOTIFICATION_GYMS, data],
    queryFn: () =>
      GymNotificationService.getGymNotificationGyms(data.status, data.searchValue).then(
        (res) => res.data
      ),
    staleTime: 5000,
  });
};

export const useGetGymNotificationByGymListingIdQuery = (
  data: IGymNotificationByGymListingIdParams
) => {
  return useQuery<IUserGymNotificationByGymResponse, Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_NOTIFICATION_BY_GYM_LISTING_ID, data],
    queryFn: () =>
      GymNotificationService.getGymNotificationsByGymListingId(
        data.currentPage,
        data.pageSize,
        data.gymListingId
      ).then((res) => res.data),
    staleTime: 5000,
  });
};

export const useGetGymNotificationByUserIdQuery = (data: IGymNotificationByUserIdParams) => {
  return useQuery<IUserGymNotificationByUserResponse, Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_NOTIFICATION_BY_USER_ID, data],
    queryFn: () =>
      GymNotificationService.getGymNotificationsByUserId(
        data.currentPage,
        data.pageSize,
        data.userId,
        data.queryOptions
      ).then((res) => res.data),
    staleTime: 5000,
    enabled: !!data.userId,
  });
};
